module.exports = __webpack_public_path__ + "static/img/messenger.90c3a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/pages/messenger.png
// module id = Xv7m
// module chunks = 134